"use strict";
var transform = require('common/transform');
var hlp = require('common/helpers');
var controller = function($scope, $rootScope, $http, upload, Flash) {
  $scope.doUpload = function() {
    $scope.loading = true;
    upload({
      url: '/api/picture',
      method: 'POST',
      data: {
        file: $('input.btn-upload[type="file"]'),
        dataStr: JSON.stringify({
          dianr: $scope.dianr,
          overwrite: $scope.overwrite
        })
      }
    }).then(function(response) {
      var message = '<strong>Erfolgreich importiert!</strong>.';
      Flash.create('success', message, 5000, {}, true);
      $scope.dianr = "";
      $scope.file = "";
      $scope.filename = "";
      $scope.overwrite = false;
      $scope.canUpload = false;
      $scope.canEditDianr = false;
      $scope.loading = false;
    }, function(response) {
      var msg = "Unkown";
      if (hlp.isSet(response.data.message)) {
        msg = response.data.message;
      }
      var message = '<strong>Fehler beim importieren! (' + msg + ')</strong>.';
      Flash.create('danger', message, 0, {}, true);
      $scope.loading = false;
    });
  };
  $scope.attachFile = function() {
    var file = $('input.btn-upload[type="file"]');
    $(file).trigger('click');
  };
  $scope.validateDianr = function() {
    if (hlp.isSet($scope.dianr) && $scope.dianr.length > 0) {
      $scope.canUpload = true;
    } else {
      $scope.canUpload = false;
      return;
    }
    var params = {
      dianr: $scope.dianr,
      overwrite: $scope.overwrite
    };
    $http.get('/api/picture/validate.json', {params: params}).then(function(response) {
      if (response.data.valid) {
        $scope.dianrExists = false;
      } else {
        $scope.dianrExists = true;
        if (response.data.reason !== undefined && response.data.reason == "document") {
          if ($scope.overwrite) {
            $scope.dianrExists = false;
          } else {
            var message = "<strong>Achtung:</strong> Es existiert bereits ein Dokument für diese DiaNr, das überschrieben werden kann (Bestehenden Eintrag überschreiben).";
            Flash.create('info', message, 5000, {}, true);
          }
        } else if (response.data.reason !== undefined && response.data.reason == "file") {
          var message = "<strong>Fehler:</strong> Für diese DiaNr besteht bereits eine Datei, die vor dem Upload gelöscht werden muss.";
          Flash.create('error', message, 5000, {}, true);
        }
      }
    }, function(response) {});
  };
  var initInputFileHandler = function() {
    $('input[type="file"]').change(function(e) {
      var fileName = null;
      if (hlp.isSet(e.target.files[0])) {
        fileName = e.target.files[0].name;
      }
      $scope.$apply(function() {
        $scope.filename = fileName;
        $scope.dianr = fileName.substring(0, fileName.lastIndexOf("."));
        if (hlp.isSet($scope.dianr) && $scope.dianr.length > 0) {
          $scope.validateDianr();
          $scope.canEditDianr = true;
          $scope.canUpload = true;
        } else {
          $scope.canUpload = false;
        }
      });
    });
  };
  var init = function() {
    initInputFileHandler();
  }();
};
module.exports = controller;
